/* ============================================================
   iTouch Wearables — global JS
   ============================================================ */

   (function () {
    'use strict';
  
    document.addEventListener('DOMContentLoaded', function () {
      initMobileMenu();
      initSearchToggle();
      initCartDrawer();
      initQuantityButtons();
      initQuantitySelectors();
      initFacets();
      initSort();
      initCollectionGridView();
      initTabs();
      initFeatureSpotlight();
      initCurrencySelector();
      initProductForm();
      initProductGallery();
      initRecommendations();
      initHeroSlideshow();
      initSocialShare();
    });
  
    /* ---------- Social share ---------- */
    function initSocialShare() {
      document.querySelectorAll('[data-social-share]').forEach(function (root) {
        root.querySelectorAll('[data-share-network="x"], [data-share-network="facebook"]').forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            const url = link.getAttribute('href');
            if (!url) return;
            window.open(url, 'share', 'noopener,noreferrer,width=600,height=480');
          });
        });
      });
    }

    /* ---------- Mobile menu ---------- */
    function initMobileMenu() {
      const toggle = document.querySelector('[data-menu-toggle]');
      const menu = document.querySelector('[data-mobile-menu]');
      const close = document.querySelector('[data-mobile-menu-close]');
      if (!toggle || !menu) return;
  
      toggle.addEventListener('click', function () {
        menu.hidden = false;
        document.body.style.overflow = 'hidden';
      });
  
      close.addEventListener('click', function () {
        menu.hidden = true;
        document.body.style.overflow = '';
      });
    }
  
    /* ---------- Search toggle ---------- */
    function initSearchToggle() {
      const toggle = document.querySelector('[data-search-toggle]');
      const bar = document.querySelector('[data-search-bar]');
      const close = document.querySelector('[data-search-close]');
      if (!toggle || !bar) return;
  
      toggle.addEventListener('click', function () {
        bar.hidden = !bar.hidden;
        if (!bar.hidden) {
          const input = bar.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });
  
      if (close) {
        close.addEventListener('click', function () {
          bar.hidden = true;
        });
      }
    }
  
    /* ---------- Cart drawer ---------- */
    function initCartDrawer() {
      const drawer = document.querySelector('[data-cart-drawer]');
      const openBtn = document.querySelector('[data-cart-toggle]');
      const overlay = document.querySelector('[data-cart-overlay]');
      const closeBtn = document.querySelector('[data-cart-close]');
      if (!drawer) return;
  
      function open() {
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
  
      function close() {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      }
  
      if (openBtn) openBtn.addEventListener('click', open);
      if (overlay) overlay.addEventListener('click', close);
      if (closeBtn) closeBtn.addEventListener('click', close);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    }
  
    /* ---------- Quantity buttons (drawer) ---------- */
    function initQuantityButtons() {
      const btns = document.querySelectorAll('[data-qty-change]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const item = btn.closest('[data-cart-item]');
          const key = item ? item.getAttribute('data-key') : '';
          const qtyEl = item ? item.querySelector('[data-qty]') : null;
          const change = parseInt(btn.getAttribute('data-change'), 10);
          let qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
          qty = Math.max(0, qty + change);
  
          if (qty === 0) {
            const removeUrl = item ? item.querySelector('[data-remove]').getAttribute('href') : null;
            if (removeUrl) {
              window.location.href = removeUrl;
            }
            return;
          }
  
          if (qtyEl) qtyEl.textContent = qty;
  
          const formData = new FormData();
          formData.append('id', key);
          formData.append('quantity', qty);
          formData.append('sections', 'cart-drawer,cart-icon-bubble');
  
          fetch(window.routes.cart_change_url, {
            method: 'POST',
            body: formData
          })
            .then(function (res) { return res.json(); })
            .then(function (data) {
              if (data.message) {
                alert(data.message);
                return;
              }
              if (data.sections) {
                const newDrawer = new DOMParser().parseFromString(data.sections['cart-drawer'] || '', 'text/html');
                const newBody = newDrawer.querySelector('[data-cart-drawer-body]');
                const body = document.querySelector('[data-cart-drawer-body]');
                if (newBody && body) body.innerHTML = newBody.innerHTML;
                updateCartCount(data.cart_count);
                updateSubtotal(data.cart ? data.cart.total_price : null);
                initQuantityButtons();
              } else {
                window.location.reload();
              }
            })
            .catch(function () { window.location.reload(); });
        });
      });
    }
  
    function updateCartCount(count) {
      const el = document.querySelector('[data-cart-count]');
      if (el) el.textContent = count;
    }
  
    function updateSubtotal(total) {
      if (total) {
        document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
          el.textContent = formatMoney(total);
        });
      }
    }
  
    function formatMoney(cents) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      return formatter.format(cents / 100);
    }
  
    /* ---------- Collection facets ---------- */
    function initFacets() {
      const form = document.querySelector('[data-facet-form]');
      if (!form) return;
  
      const checkboxes = document.querySelectorAll('[data-facet-filter]');
      checkboxes.forEach(function (cb) {
        cb.addEventListener('change', function () {
          syncFormFromUI();
          form.submit();
        });
      });
  
      const applyBtn = document.querySelector('[data-facet-price-apply]');
      if (applyBtn) {
        applyBtn.addEventListener('click', function () {
          const minInput = document.querySelector('[data-facet-price-min]');
          const maxInput = document.querySelector('[data-facet-price-max]');
          form.querySelectorAll('input[name*="filter.v.price"]').forEach(function (h) { h.remove(); });
          if (minInput && minInput.value) {
            const h = document.createElement('input');
            h.type = 'hidden';
            h.name = minInput.getAttribute('name');
            h.value = minInput.value;
            form.appendChild(h);
          }
          if (maxInput && maxInput.value) {
            const h = document.createElement('input');
            h.type = 'hidden';
            h.name = maxInput.getAttribute('name');
            h.value = maxInput.value;
            form.appendChild(h);
          }
          form.submit();
        });
      }
    }
  
    function syncFormFromUI() {
      const form = document.querySelector('[data-facet-form]');
      if (!form) return;
      form.querySelectorAll('input[name]').forEach(function (h) {
        if (h.dataset && h.dataset.facetHidden) h.remove();
      });
      document.querySelectorAll('[data-facet-filter]:checked').forEach(function (cb) {
        const h = document.createElement('input');
        h.type = 'hidden';
        h.name = cb.getAttribute('name');
        h.value = cb.value;
        h.dataset.facetHidden = '1';
        form.appendChild(h);
      });
    }
  
    /* ---------- Sort ---------- */
    function initSort() {
      const select = document.querySelector('[data-sort-select]');
      if (!select) return;
      select.addEventListener('change', function () {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.href = url.toString();
      });
    }
  
    /* ---------- Collection grid view ---------- */
    function initCollectionGridView() {
      const grid = document.querySelector('[data-product-grid]');
      const buttons = document.querySelectorAll('[data-grid-view]');
      if (!grid || !buttons.length) return;
  
      const storageKey = 'collection-grid-view';
      var saved = window.localStorage.getItem(storageKey);
      // Migrate: old "2" button → 3 per row
      if (saved === '2') saved = '3';
      const initial = saved || grid.getAttribute('data-cols') || '4';
  
      setGridView(grid, buttons, initial);
  
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const view = btn.getAttribute('data-grid-view');
          setGridView(grid, buttons, view);
          window.localStorage.setItem(storageKey, view);
        });
      });
    }
  
    function setGridView(grid, buttons, view) {
      var mode = String(view || '4');
  
      // Migrate old value "2" (previous 2-col button) → 3 per row
      if (mode === '2') mode = '3';
      if (mode === 'list' || mode === '1') {
        mode = 'list';
      } else if (mode !== '3' && mode !== '4') {
        mode = '4';
      }
  
      grid.classList.remove('product-grid--2', 'product-grid--3', 'product-grid--4', 'product-grid--list');
  
      if (mode === 'list') {
        grid.classList.add('product-grid--list');
        grid.style.setProperty('--grid-cols', '1');
        grid.style.gridTemplateColumns = '1fr';
        grid.setAttribute('data-cols', 'list');
      } else {
        var cols = mode;
        // Mobile: show at most 2 columns for grid modes
        if (window.matchMedia('(max-width: 600px)').matches) {
          cols = '2';
        }
        grid.classList.add('product-grid--' + mode);
        grid.style.setProperty('--grid-cols', cols);
        grid.style.gridTemplateColumns = 'repeat(' + cols + ', minmax(0, 1fr))';
        grid.setAttribute('data-cols', mode);
      }
  
      buttons.forEach(function (btn) {
        var btnView = btn.getAttribute('data-grid-view');
        var active = btnView === mode || (mode === 'list' && btnView === 'list');
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
  
    /* ---------- Product info tabs ---------- */
    function initTabs() {
      document.querySelectorAll('[data-product-info-section]').forEach(function (root) {
        const tabBtns = root.querySelectorAll('.product-description__tab-btn');
        const panels = root.querySelectorAll('.product-description__panel');
        if (!tabBtns.length || !panels.length) return;
  
        tabBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            const name = btn.getAttribute('data-tab');
            if (!name) return;
  
            tabBtns.forEach(function (b) {
              b.classList.toggle('is-active', b === btn);
            });
  
            panels.forEach(function (p) {
              p.classList.toggle('is-active', p.getAttribute('data-panel') === name);
            });
          });
        });
      });
    }
  
    /* ---------- Feature spotlight tabs ---------- */
    function initFeatureSpotlight() {
      document.querySelectorAll('[data-feature-spotlight]').forEach(function (root) {
        const tabs = root.querySelectorAll('[data-spotlight-tab]');
        const panels = root.querySelectorAll('[data-spotlight-panel]');
        if (!tabs.length || !panels.length) return;
  
        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            const id = tab.getAttribute('data-spotlight-tab');
  
            tabs.forEach(function (t) {
              const active = t === tab;
              t.classList.toggle('is-active', active);
              t.setAttribute('aria-selected', active ? 'true' : 'false');
            });
  
            panels.forEach(function (panel) {
              panel.classList.toggle('is-active', panel.getAttribute('data-spotlight-panel') === id);
            });
          });
        });
      });
    }
  
    /* ---------- Currency / country selector ---------- */
    function initCurrencySelector() {
      document.querySelectorAll('[data-currency-selector]').forEach(function (root) {
        const toggle = root.querySelector('[data-currency-toggle]');
        const list = root.querySelector('[data-currency-list]');
        const input = root.querySelector('[data-currency-input]');
        const form = root.querySelector('form');
        if (!toggle || !list || !input || !form) return;
  
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          const open = list.hasAttribute('hidden');
          if (open) {
            list.removeAttribute('hidden');
            toggle.setAttribute('aria-expanded', 'true');
          } else {
            list.setAttribute('hidden', '');
            toggle.setAttribute('aria-expanded', 'false');
          }
        });
  
        root.querySelectorAll('[data-currency-option]').forEach(function (option) {
          option.addEventListener('click', function (e) {
            e.preventDefault();
            input.value = option.getAttribute('data-value');
            form.submit();
          });
        });
  
        document.addEventListener('click', function (e) {
          if (!root.contains(e.target)) {
            list.setAttribute('hidden', '');
            toggle.setAttribute('aria-expanded', 'false');
          }
        });
      });
    }
  
    /* ---------- Product quantity selectors ---------- */
    function initQuantitySelectors() {
      document.querySelectorAll('[data-qty-selector]').forEach(function (root) {
        const input = root.querySelector('[data-qty-input]');
        const decrease = root.querySelector('[data-qty-decrease]');
        const increase = root.querySelector('[data-qty-increase]');
        if (!input) return;

        function setQty(next) {
          const min = parseInt(input.getAttribute('min'), 10) || 1;
          input.value = Math.max(min, next);
        }

        if (decrease) {
          decrease.addEventListener('click', function () {
            setQty((parseInt(input.value, 10) || 1) - 1);
          });
        }
        if (increase) {
          increase.addEventListener('click', function () {
            setQty((parseInt(input.value, 10) || 1) + 1);
          });
        }
      });
    }

    /* ---------- Product media gallery ---------- */
    function initProductGallery() {
      const section = document.querySelector('[data-product-section]');
      if (!section) return;

      const gallery = section.querySelector('[data-product-gallery]');
      if (!gallery) return;

      const mainImage = gallery.querySelector('[data-product-main-image]');
      const thumbsRoot = gallery.querySelector('[data-product-thumbs]');
      const track = gallery.querySelector('[data-product-thumbs-track]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-product-thumb]'));
      if (!mainImage || !thumbs.length) return;

      function getVisibleCount() {
        if (!thumbsRoot) return 7;
        const fromCss = parseInt(window.getComputedStyle(thumbsRoot).getPropertyValue('--thumb-visible'), 10);
        if (!isNaN(fromCss) && fromCss > 0) return fromCss;
        return Math.max(1, parseInt(thumbsRoot.getAttribute('data-visible-count'), 10) || 7);
      }

      function getActiveIndex(mediaId) {
        return thumbs.findIndex(function (thumb) {
          return String(thumb.getAttribute('data-media-id')) === String(mediaId);
        });
      }

      function updateThumbWindow(activeIndex) {
        if (!track || !thumbsRoot) return;

        const visibleCount = getVisibleCount();
        if (thumbs.length <= visibleCount) {
          track.style.transform = 'translateX(0)';
          return;
        }

        const half = Math.floor(visibleCount / 2);
        const maxStart = thumbs.length - visibleCount;
        let start = activeIndex - half;
        if (start < 0) start = 0;
        if (start > maxStart) start = maxStart;

        const thumbWidth = thumbs[0].getBoundingClientRect().width;
        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 8;
        const offset = start * (thumbWidth + gap);
        track.style.transform = 'translateX(-' + offset + 'px)';
      }

      function selectMedia(mediaId, src, alt) {
        if (src) {
          mainImage.src = src;
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
        }
        if (alt != null) mainImage.alt = alt;
        if (mediaId != null) mainImage.setAttribute('data-media-id', String(mediaId));

        let activeIndex = 0;
        thumbs.forEach(function (thumb, i) {
          const active = String(thumb.getAttribute('data-media-id')) === String(mediaId);
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
          if (active) activeIndex = i;
        });

        updateThumbWindow(activeIndex);
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          selectMedia(
            thumb.getAttribute('data-media-id'),
            thumb.getAttribute('data-media-src'),
            thumb.getAttribute('data-media-alt')
          );
        });
      });

      const initialId = mainImage.getAttribute('data-media-id');
      const initialIndex = getActiveIndex(initialId);
      updateThumbWindow(initialIndex >= 0 ? initialIndex : 0);

      window.addEventListener('resize', function () {
        const currentId = mainImage.getAttribute('data-media-id');
        const idx = getActiveIndex(currentId);
        updateThumbWindow(idx >= 0 ? idx : 0);
      });

      gallery._selectMedia = selectMedia;
    }

    /* ---------- Product form (variant selection) ---------- */
    function initProductForm() {
      const section = document.querySelector('[data-product-section]');
      if (!section) return;

      const variantsJson = section.querySelector('[data-product-variants]');
      if (variantsJson) {
        try {
          window.productVariants = JSON.parse(variantsJson.textContent);
        } catch (e) {
          window.productVariants = [];
        }
      }

      const optionInputs = section.querySelectorAll('[data-option-position]');
      if (!optionInputs.length) return;

      const form = section.querySelector('form.product-form');
      const submitBtn = section.querySelector('.product-form__submit');
      const submitText = submitBtn ? submitBtn.querySelector('[data-add-to-cart-text]') : null;
      const idInput = form ? form.querySelector('input[name="id"]') : null;
      const gallery = section.querySelector('[data-product-gallery]');

      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          const optionField = input.closest('.product-form__option');
          const selectedLabel = optionField ? optionField.querySelector('[data-option-selected]') : null;
          if (selectedLabel) selectedLabel.textContent = input.value;

          let variantId = null;
          let available = false;

          const selected = {};
          section.querySelectorAll('[data-option-position]:checked').forEach(function (i) {
            selected[i.getAttribute('data-option-position')] = i.value;
          });

          let matchedVariant = null;
          if (window.productVariants) {
            for (const v of window.productVariants) {
              let match = true;
              for (const pos in selected) {
                if (v.options[pos - 1] !== selected[pos]) {
                  match = false;
                  break;
                }
              }
              if (match) {
                matchedVariant = v;
                variantId = v.id;
                available = v.available;
                break;
              }
            }
          }

          if (idInput && variantId) idInput.value = variantId;
          if (submitBtn) {
            if (available) {
              submitBtn.removeAttribute('disabled');
              if (submitText) submitText.textContent = window.variantStrings ? window.variantStrings.addToCart : 'Add to cart';
            } else {
              submitBtn.setAttribute('disabled', 'disabled');
              if (submitText) submitText.textContent = window.variantStrings ? window.variantStrings.soldOut : 'Sold out';
            }
          }

          if (matchedVariant && matchedVariant.featured_image && gallery && gallery._selectMedia) {
            gallery._selectMedia(
              matchedVariant.featured_media_id,
              matchedVariant.featured_image,
              null
            );
          } else if (matchedVariant && matchedVariant.featured_image) {
            const mainImage = section.querySelector('[data-product-main-image]');
            if (mainImage) {
              mainImage.src = matchedVariant.featured_image;
              mainImage.removeAttribute('srcset');
              mainImage.removeAttribute('sizes');
            }
          }
        });
      });
    }
  
    /* ---------- Hero slideshow ---------- */
    function initHeroSlideshow() {
      const root = document.querySelector('[data-hero-slideshow]');
      if (!root) return;
  
      const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
      if (slides.length < 2) return;
  
      const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
      const autoplay = root.getAttribute('data-autoplay') === 'true';
      const intervalMs = parseInt(root.getAttribute('data-interval'), 10) || 5000;
      let index = 0;
      let timer = null;
  
      function goTo(nextIndex) {
        const total = slides.length;
        index = ((nextIndex % total) + total) % total;
  
        slides.forEach(function (slide, i) {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          if (active) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
          slide.querySelectorAll('a, button').forEach(function (el) {
            if (active) {
              el.removeAttribute('tabindex');
            } else {
              el.setAttribute('tabindex', '-1');
            }
          });
        });
  
        dots.forEach(function (dot, i) {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
  
      function next() {
        goTo(index + 1);
      }
  
      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }
  
      function start() {
        stop();
        if (!autoplay) return;
        timer = setInterval(next, intervalMs);
      }
  
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          const i = parseInt(dot.getAttribute('data-index'), 10);
          if (!isNaN(i)) {
            goTo(i);
            start();
          }
        });
      });
  
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
  
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });
  
      start();
    }
  
    /* ---------- Product recommendations ---------- */
    function initRecommendations() {
      const container = document.querySelector('.product-recommendations[data-url]');
      if (!container) return;
  
      const url = container.getAttribute('data-url');
      if (!url) return;
  
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (text) {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const content = html.querySelector('.product-recommendations[data-recommendations]') || html.querySelector('.product-recommendations');
          const grid = container.querySelector('[data-recommendations]');
          if (content && grid) {
            grid.innerHTML = content.innerHTML;
          }
        })
        .catch(function () { /* silent */ });
    }
  })();
  